export interface MuRoutingData {
  breadcrumb: string;
}

export const MuRouteData = (data: MuRoutingData): MuRoutingData => {
  return data;
};
